import moment from "moment";
import React, { lazy } from "react";
import GrafoButton from "../../../../_generic/GrafoButton";
import AssessmentSummarySection from "./AssessmentSummarySection";

import AssessmentSummaryTitle from "./AssessmentSummaryTitle";
import AssessmentSummaryPain from "./AssessmentSummaryPain";
import { useData } from "../../../_generic/contexts/DataContext";
import {html2pdf} from "html2pdf.js"

function AssessmentSummary({ patient, form, notes, assessment }) {
  const ref = React.createRef();
  

  const data = useData();
  const user = data.user;

  const getPatient = () => {
    const summary = {
      "First Name": patient.firstName,
      "Last Name": patient.lastName,
      "Date Of Birth": patient.dob
        ? moment.utc(patient.dob).format("Do MMM YYYY")
        : "",
      Email: patient.email,
      Address: patient.address,
      Occupation: patient.occupation
    };

    return Object.keys(summary).map((k) => {
      return { key: k, value: summary[k] };
    });
  };

  const getMedical = () => {
    return !patient.medical
      ? []
      : Object.keys(patient.medical).map((k) => {
          return { key: toTitleCase(k), value: patient.medical[k] };
        });
  };

  const getForm = () => {
    return !form || !form.answers
      ? []
      : form.answers.map((f) => {
          let answer = f.answer;

          if(Array.isArray(answer)){
            answer = answer.map(a => a.value).join(", ")
          }

          return { key: f.label, value: answer };
        });
  };

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  if (!patient) {
    return (
      <div>
        There was no patient to show. If you think this is an error, please
        contact us.
      </div>
    );
  }

  return (
    <React.Fragment>
      <GrafoButton
        onClick={() => {
          var element = document.getElementById("container");
          html2pdf().from(element).save();
        }}
      >
        Save as PDF
      </GrafoButton>
      <div id="container" style={{ padding: "30px" }} ref={ref}>
        <div style={{ textAlign: "right" }}>
          <img
            style={{ width: "150px" }}
            alt="logo"
            src={
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAABbCAYAAABTRzgMAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABKFSURBVHgB7Z1PjBxHFca/6t14dyNINkjAmgCuKBwQBMU+gBQubkuIxOEQW0hw9PjA2WuF+7Y5g2yfQfL4CFKUzYHY5uL2BQ4cshbhBnInEOyEQzZBih3b00W9rqrpntmZnuo/M9PTUz+pdnZmqqu7q+qrevWqqgdwOBxLB4PD4RgFl+GUDC/q/7n+fF+H2zKEMuzC4XAsPL4MN2UQFuEOHA7HQrMpw5uwE7wTvsPRAjiUiAWc8B2OpaGM6Bda+B4cjuXmIlLHncPhWAI4yvX0rsd3OBaYAEvKKhyO5eV4gbg0d/+WDJF+v6mDw+FYIHzYm/SX4ETucLSCbdiJ/gpaiBvjO5YV2x78KlqIE75jWeGW8UK0kL5z7/D13rYAew1q7NNmImnBhRAPL9w7uRHB4VhCkh5/63rvihQ9LWTw0X44wDpgaze3rt3ncDiWEG/r2uNOIoTlg0vxt9Jx43BMYpV53jkhsKz41OvPwOQnR9JRDI4rzb7uPf26bFB++FD73Sl/OFKHW6Rfb+v/Q6h8aht0v7Tnn/LiCNJ8ICL9Snmwlwm1sCpFfxRLzRO+/NNF/fhQhUp+Ez4hbgjlPe4OfX4TkzmLtJKMg8r4IiZzYug9VcQO1EKX4YaLeM7i3MPpndNp8px45js/81kElU8XUOycHRnOjPjctt7nlQE12KdRnA7UNfk5cbh+zcaJoO4/RLE8OIBbuVc/HGru1y9wjK/DDlTBdjOf18FmwbSMQLdR38IVSmunQnocSjAUAqh8sj3OR3n8nO8iFKMDlQcc5eBQdSuCqiO2eXAAN51XL1S530H5isahCnYH84ND9XIB6hP9RR3qSi+AyudFWU3HofL0CurZCcih8uAOSqbnevz6oELtoB4CGT7BfKAKylEfdeZLFjLV6VppeNJkHwlH/XmaTZsaQBru7RY50PX49TCNyj2PXr+KGToK6uU7mB4k/nlaR5Og6yNhckwP88iwM0UOWhjhPyVtk18cUeEbG2gSVPE6qJ95mLEB6qMDNfSZNnQOH82DQwlyVuXYRYF8WAhTn8T+y2+xRPzEr74N/PofAr/5J+ZNB0u8pzsHjuI98XtITXYztWULnStEs5iWeZ8HNTTHYOF0bHyP//rzJPRU9AZqCOi7OcJR3sykCp6t6G2DpjG5RTy6f/JMP6PjH9WB3lMFtt0g46NZvX7ZIZOpF7dRrm5QY2m1KK3RPT4JmwQ+DvXd3Hp+mu7iBeLfgnLAdDFYqBzpVB5HOzhnESeCcsxFY76nxSod/b1NA+tjdK+/O+Yck+bRDWdzvhslTo5iViClcRnq2sMRafkoVjcoPjW8uc6+xgp/kugNcxI/h8pcW85DPcxhFBFUY0AhQPOcVeZXY7Irx8wKs1EVf9RCn1HkiT5LALWAyJ8Qb9zTdLLXncWHHV0UIygQl66LFgBFY76P9Pl3dbo2DSqxg0UUvhnT2zIH8fuwb4HzRD9MAFXYVubalDE90SUUMzs3dfy8MXoXxRa/kMnvT4jDMX847L3rJEzbVX+Un9v61aZjMMuhw3ERGjnGv/4R8K/7hQ5JxE8NxoywLVwjnCJ09XHzJIIaYwcoPtYMkY7RqWLTvdwaimM7ds9ezyQ45o9vGS9C/hBiHAHsnZi5dbRRwv/hM+qVRP/Tv4rC4n/9eXsroSI267xJMEVFbwgwP8dfBHszPA8yY6lXM9NtVDjUGJxF8c0mr2ExsB3+kUOzbPmetTw291oaI/yffQ144wcMl15Q4i0j/qefAL4+/Tl+Ev2mRbxxTiUbqGCL9op1UXQTTBFI8F3YVVyzo5FM21msB6iDFy3iRKi2KSzCQQtqFMYPM5JGjPFJ9Je/pwT/82fpL8P2u6Iv/je+z6wW7XzyCPh3QSuhBDaiJ95CNYr2inVAguxitnCkDkEKR2DvIGwSuULLEKI6XdhZQT7GlOfchZ8VvaGs+H/3PmYBt4xX1VSfh/BtepIqmG2+1DP6aM/0JWEz/COqdgiEbd0Y20nN1dQfJXoDib+I2U8efVrN1yAiVGMeY/wQ08GHWsn2MdL1+xzLSR3lGlnGa57w80RvsBV/A0W/qESoF7OBhETvo93YDgFnydh5rrkI30b0hknib7DobU2/cXDMnjqtDA61M83W0+2on7Fbu2cu/CKiN4wT/5xEH1nG46hG1YZjnnDUs0nFrBoM0XxsG81ZWgZjr2mmzr0yojcMO/x+9GeBTx9jHtg6VsjregnlWZS561EEKCZ62phC+RplXk0gfDR/qBBZxuOojm2nMH/hVxG9ISv+OYmeMDuoJq0T9DFh2WQOHIs7JvZhv7KR1gwUXRLcVGzvwUe1DoGwFf7YTmompn4dojewmS3Oy2XXMh6tuS9j2tk8XbepdCzj0R6GAPaLeZqO6RAmQZuJqt6P7Wad+Qm/TtH/4T/yjv/WCEeerfA5lIhtC9rsp+ZYXGxWr9F6gSK9HsdiYFMvqIy3UZ4O7Hp8Ev3YRnWqwm+p6IkQ9iY8FZLNk3fpe2okOlhsbCpliGL4WAxsOwRahlzGecthv207dzHW1Mb4LRa9gcanvmVcDiVqaoVvYdAEowpgVrItOtMwyTkWx9EZYvKWZAOtbyiyGYqj2ExJrkU1FeEvgeiJUAff/pD+o6Xaiq2Dq8gG6gCLBW1DtumVOdRz8W2e1+Cj2BCwiwkNSu2m/pKI3mC7RXKZsN0yyi3ikYBsZwiaAok4KhCfljDf0cdRvvhIn/BE938TxddEXJgUodYef8lET0RQ5loRB17boWGMPyEO5RXl2WmMfyzWDhZz+EMNH3UIRWZmOJSn3tZbn4fVturaevwlFL2BKu40ev49LCa2u884lNOTAo13r+j/aSPPoq/tDzGfpyhRnQlsItYi/CUWvYG8uVbPM7eECnCiudZQuiiWD+TzILO2A/uHnCwCNGUXYnZEKPDLvZWF70TfJ4Iy+6+iGlfR/N+Dy8OYunUTWsRpWqMxbihTNxEKPi6tkvDpUVdO9ANEUD3Xc1ACLiJemuY7oY9fdIdhiHotFvJ826yKa5rwqRzJEpym2W/qTVTkoErOve98AbXQEtFniZAuxPF1MGasCRHSTSkhDvYMtpU4QjMJ9KvtgpNxmPX8gUXcpg4TyOyn8q37R1MobwKUoJLwX3gKlWmh6IcJUX6jziSabhkESH8Jh6MYEdSQIdTvbe6Vo7lO0S7UvQRQC5KqNFLUy3dQodGvJPyXvoRKtEj05omwtAHDh2qJQ1TDt4gTwQ4z81BXekXo6tDR4fiE+Lcyx2QhB+ok8RcRfRez3+cfIX3smI/0+YM2jQDlS4iadjNWEv43N8qP71sgehK6D9V6D3ujTSFVwWazi21Fp4rSxXzp6mAaSTPkMZh9+OMqdYR67yHE/Igw2LhRfnAdTJ7s6zApX0pRWvjk2PvuF1GKBRe9j8m/e04LMaq0zB3Ymca3sHhQnoRwZNnDjIcopb36ZR17LejpbTZh0PdlnVq8wLEhHI4SlBZ+GcdeS8b0ufucM5Ant6j4OZQ1wS3iUm8fweEoQWnhF3Xstcx7bzsvG8B+V1UHaqnqUdjRhcNRktJjfFvH3t//p379tmXPvafxO43jbbyxHR1CpL20GS5QICfeKRSb3onghO+oQGnhj3Lskcjf/ZReBf7yMfD+Z5jnQzGnCQnXdt+1wUd9G09OoEa2rj3ypfEng4junVztogUcvvH4lIjZ0TbdU52UFj496falZ9gyiHwcAdKpvFlite2yGJ4PxnYgmJlDT9i6Hif7wEUsLn/46sollGDzTbG5viGU34LFwb2XV6vuZbBCiv6UvKczw/fkUJQe4//+AyX+376nevklE72BNmFEmB3W2y6roqwA/VCIFVb6YRgbT/Z8k46IPevdY23j8PXetmxI73z17V6pBrRu5vqjmS0gQokNEiXZQ80mfh7r66tm4YjsqEXpX3hdO7QS9tOBmOlcdZMQQi3SYR6eRgOY+89kt4AISpD0CKVTmA5kHtP0YK2rt/KITjA613Nb1wS/d9KLUBKTDpn8+6e9mV2/Ix8n/HqIoMz+DurdgUVCMbvTSpGMsdd7skFinN7HQux99Orqrs2xykHW29y6dj+8d3Ijos+oIQB6fiywT+lQ+hsbcUf2aJvkSAMe9eMatq497shjkE1n8HvjXFTX57FHe6PiDd9LL+7t/vcnh/ZU+sSjkelP4tk/PTza63naEfhESNfDmHeU7mlSfmXjMoZ9IR7uDl9Dko+CHVHvGE+vV51v1P1RWo97vZDub9x5s3lmW6YGJ/x66SJ98m6VBoAKm8zrShsyaFwJJnaE8PpThZ6sUXKsGcVxfH5SZZFj8kvSPj8C8QRt8Onqj6Uj0LviMURbN3ovShs2EDISktld+rMWSYGfGKj8Mr5KcCAdJbh4dWDBkpf8VNIaZNrSEbhyYTAuOQm9ftyVldUdiicdeMGo9G3p9VZOKecmbh2+0XtHinRb6Nsx+fXgPju2f5r1yyJpAJmg+/JNXPW6dnHreq/74L533sTv52Oaf776V3ShV18Ol5VQ94fhtJJzK6ern80zukaI3tlsQ5KHE379REg3YJiNPBQ4Rm+8oQKVLtL+eu1d1OAzoF5FCvIi1aCkJ5LjdMbYplDXwD3Puyh7mDBboQrCE8EJWptAPT2TQkh23snXNRLEifzrE1wJGdxcn/pGpcPAtr/8x4dvqR5dcNmrJQ80HYjL2PG+6OtAnleK/nj/nih9vXlmfT2moVaQxhXpk28P5AHryJkM+i7JAyHErsz713R8KVCh91io12xZmbR0Wb1Gaa09GVMZnTdxoUVPsy3JpXgm7ccRLHHCny5GzLP35DLPrDGI7n9GvZWX6a1kL4mH3f3TG9XG3EJcuHdyJcik26UpNGE1xRkH2mSPRPz5gIVAldvz4r3UzI0DKUgt+s+PZeMevhG/Kc3s2nwrUkzns1OXpncVSlyBuT70RR+fza4TSPKWrAd5DJnj1APL9Lbl55vyc3mMkMORlcEt0rqs5P3t3n0lnflIziOtJSYtEGlFXVb3zbj+OqJ09f/bX3n78amPXrUf5jivfgvRU3E8eSPY2eFencRaZix8kIfd7DvmiWToIK3eTRqv5h2peykoIQxeCwnpgx+nY1sTl3rO4bhrh9hZ1IRssPYPrFfQvTMTmZWVzDujvsJbw4uDdEMYZuPlkS0r2ejcJrGbkCTB1FBPiEO6cYtDfSin6UETr+gY3wm/hUih9CvpvZMsxBQgkQyLUFbcfgOzvv4gV/jCCKlv9paLm8waCKvn8U1Eivv2wU9HzGiI5JmK46cnhVDXI9hzmMgqTy9AWgrkD8kEc++yAUheyYKQ5zV7RTjFSRqAG71CG8KW3tSPvfb9Ek4iQL2VQpqIvJ7efRBW09QimfBV49LcuJjhVhB5vo/l+Y4IMXp/hfRPbNpeDvN6ciZA9b80Zjc9/EH6PT3uvkJDB7Ku4g5ZQ/I6En+LHE6w7NArDzpjiCXGix/toWXoxTcJwjt04NdZpNPMYgw+dUL6k5r8KeTMGxoqjI1L3vBxApwaxvLw2BlqWLNf0bULZn7kM+4ePJQ9k32vFzglkOjVMCwNNGWp/h+c9iNLTn7eETE7JhO9qhOwXmG5SquypOPCxxJCY7QPp9Abzhsyf6UgLktP8bnEMXRdOpZEfDWWPaa3wl5Meoeh6bJZw1h8WfZ0PsgJJh1ocnrxssfEfjInDnFubQP7UlSnE2tFXrueAkviymkrdd2eR174ADNGXvcl6c84A2pw2NpNOc6+oDzx6tp1tIjWFZhjEsdk8g+Om7l/mqeXZbVnyopMfVlWR/LKSjn8xA6dsxfHsoF/sM+8tcTiEczeCvPuSmdGZsywTEQMn2+jpayteYGsbLrnZ7KyrNyUU3hv9qe/Yjaz5b+juPuydEbJWQH91k+uTV5jMq1FU3yZbcrkQMvUUZ/iJUHdS8TYbIdrsreVMxHxef2Wq/F45trl9ax4j09nh1hCxH3Hp4m74q0kDrsiZcXgnTLnlPP878iG546Z1WCy8YQlyeCCxgw0LUFziLPOxJlDjiBZ4WhBxr0W9vYG6vXvvuwdM+Wq7jsJt9QUlOenseUctPxces0Hhj2MpiL7c9T6MzkmVWkcdLStxKv6O9x68GA9rUf6s2w6RDIeFewEo8VK+vrk/7dHlU+2jpq4yTy2+PwE4pHpj7yn0Yixccfdb+LNJ+edNLPVNZv8FRdoyjE7K6HiS1NdXn8mbv96i5TV3ZNS+GPjDc4wOBwOh8PhcDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcjkr8HzP4lPtZY0exAAAAAElFTkSuQmCC"
            }
          />
        </div>
        <div style={{marginTop:"-50px", marginBottom:"50px"}}>
          <b>
            {user.firstName} {user.lastName}
          </b>
          {user.title ? <i>, {user.title}</i> : ""}
          <br />
          {user.phone && (
            <React.Fragment>
              {user.phone}
              <br />
            </React.Fragment>
          )}
          {user.email && (
            <React.Fragment>
              {user.email}
              <br />
            </React.Fragment>
          )}
          {user.address && (
            <React.Fragment>
              {user.address}
              <br />
            </React.Fragment>
          )}
        </div>
        <AssessmentSummarySection
          showColons={true}
          title={"Client Information"}
          fields={getPatient()}
        />
        {getMedical().length > 0 && (
          <AssessmentSummarySection
            showColons={true}
            title={"Medical Contact"}
            fields={getMedical()}
          />
        )}
        {getForm().length > 0 && (
          <AssessmentSummarySection
            showColons={true}
            title={"Form"}
            fields={getForm()}
          />
        )}
        <div style={{ marginBottom: "70px" }}>
          <AssessmentSummaryTitle>Pain Points</AssessmentSummaryTitle>
          <AssessmentSummaryPain assessment={assessment} />
        </div>
        {notes && (
          <AssessmentSummarySection title="Treatment">
            <div dangerouslySetInnerHTML={{ __html: notes.content }}></div>
            {notes.attachments && (
              <div>
                {notes.attachments.map((at) => (
                  <img alt={at} key={at} src={at} />
                ))}
              </div>
            )}
          </AssessmentSummarySection>
        )}
      </div>
    </React.Fragment>
  );
}

export default AssessmentSummary;
